<template>
    <div class="changepassword">
        <!-- <div class="header">
			<img src="../../image/back.png" class="back" @click="back" />
			<div class="imgBox"><img src="../../image/logo-m.png" alt=""></div>
		</div> -->
        <v-header :go-back="true" :forgetPsw='true'></v-header>
        <!-- <div class="title">{{$t('my.changePsd')}}</div> -->
        <div class="changepassword-main">
            <div>
                <el-input :placeholder="$t('changepassword.oldPsd')" v-model="oldpassword" type='password' style="width:80%;margin: auto;display:block;" @change='oldpasswordver'></el-input>
                <p class="danger" v-show='flag'>{{$t('changepassword.notPsd')}}</p>
                <p class="danger" v-show="flag1">{{$t('changepassword.falsePsd')}}</p>
                <el-input :placeholder="$t('changepassword.newPsd')" v-model="newpassword" type='password' style='margin: auto;width:80%;display:block;margin-top:15px;' @change='newpasswordver'></el-input>
                <p class="danger" v-show='flag2'>{{$t('changepassword.notPsd')}}</p>
                <p class="danger" v-show="flag3">{{$t('changepassword.lessPsd')}}</p>
                <el-input :placeholder="$t('changepassword.againPsd')" v-model="confirmpassword" type='password' style='margin: auto;width:80%;display:block;margin-top:15px;' @change='conpasswordver'></el-input>
                <p class="danger" v-show="flag4">{{$t('changepassword.notSamePsd')}}</p>
            </div>
            <div class="next-btn">
                <el-button type="primary" style='margin: auto;display: block;width: 80%;' @click='finish'>{{$t('changepassword.trueChange')}}</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import { updateUserInfo,getLoginUser } from "../../api/index.js";
import header from "../../components/header.vue";
import axios from "axios";
import Qs from "qs";
export default {
    name: "changepassword",
    data() {
        return {
            oldpassword: "",
            newpassword: "",
            confirmpassword: "",
            flag: false,
            flag1: false,
            flag2: false,
            flag3: false,
            flag4: false
        };
    },
    created() {
        if (sessionStorage.getItem("login")) {
            this.loginsuccess = true;
            this.loginshowflag = false;
        }
        //检验是否登录超时
        if (sessionStorage.getItem("login") == 1) {
            getLoginUser()
            .then(res => {
                if (res.data.header.status == 3019) {
                sessionStorage.setItem("login", "1");
                this.$message({
                    type: "success",
                    message: this.$t("prompt.header")
                });
                this.$router.push("/login");
                }
            })
            .catch(err => {});
        }
    },
    methods: {
        back() {
            this.$router.replace({ path: "/myAccount" });
        },
        oldpasswordver() {
            if (this.oldpassword.length > 0) {
                this.flag = false;
            }
        },
        newpasswordver() {
            if (this.newpassword.length > 0) {
                this.flag2 = false;
            }
        },
        conpasswordver() {
            if (this.newpassword == this.confirmpassword) {
                this.flag4 = false;
            }
        },
        finish() {
            if (this.oldpassword.length == 0) {
                this.flag = true;
            } else {
                this.flag = false;
            }
            if (this.newpassword.length == 0) {
                this.flag2 = true;
            } else {
                this.flag2 = false;
            }
            if (this.newpassword.length > 0 && this.newpassword.length < 6) {
                this.flag3 = true;
            } else {
                this.flag3 = false;
            }
            if (this.newpassword != this.confirmpassword) {
                this.flag4 = true;
            } else {
                this.flag4 = false;
            }
            if (
                this.flag == false &&
                this.flag2 == false &&
                this.flag3 == false &&
                this.flag4 == false
            ) {
                let params = Qs.stringify({
                    oldPassword: this.oldpassword,
                    newPassword: this.newpassword
                });
                updateUserInfo(params)
                    .then(res => {
                        // console.log(res);
                        if (res.data.header.status == 1000) {
                            this.$router.replace({ path: "/myAccount" });//replace跳转到指定的url，不会向history里面添加新的记录，点击返回，跳转到上上个页面
                        } else {
                            this.flag1 = true;
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        }
    },
    components: {
        "v-header": header
    }
};
</script>
<style>
.changepassword .el-button--primary {
    background-color: rgb(9, 81, 150);
    border-color: rgb(9, 81, 150);
}
.changepassword .el-input__inner{
    border: 0;
    border-bottom: 1px solid #cccccc;
    border-radius: 0;
}
.changepassword .el-button--primary{
    width: 72%;
    margin-left: 14%;
    font-size: 1rem;
    height: 2.6rem;
    line-height: 2.6rem;
    color: rgb(255,255,255);
    margin-top: 52px;
    border-radius: 1.3rem;
    background-image: linear-gradient(to right , #65d3e8, #7dc3f2);
    border: 0;
    padding: 0 0;
}
</style>

<style scoped>
.title {
    color:#828282;
    width: 100%;
    font-size:.80rem;
    text-align:center;
   
}
.changepassword-main {
    width: 100%;
    margin-top:4rem;
}
.danger {
    font-size: 0.625rem;
    margin-top: 5px;
    color: red;
    margin-left: 10%;
}
.next-btn{
    margin-top: 52px;
}
</style>


// WEBPACK FOOTER //
// src/m_page/myAccount/changepassword.vue